import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["BlitzProvider"] */ "/vercel/path0/src/app/blitz-client.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/styles/index.css");
